"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _util = require("../../util");

var base = function base(_ref) {
  var theme = _ref.theme;
  return /*#__PURE__*/(0, _react.css)("background-color:", theme.color.monochrome.white, ";border-radius:", (0, _util.rem)(4), ";display:flex;align-items:center;padding:", (0, _util.rem)(8), " ", (0, _util.rem)(24), " ", (0, _util.rem)(8), " ", (0, _util.rem)(12), ";cursor:pointer;transition:box-shadow 0.3s;&:hover{box-shadow:0 2px 6px 0 rgba(", theme.color.monochrome.black_rgba, ", 0.15);}" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

var imageBox = /*#__PURE__*/(0, _react.css)("margin-right:", (0, _util.rem)(12), ";display:flex;align-items:center;svg{width:", (0, _util.rem)(32), ";height:", (0, _util.rem)(32), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:imageBox;"));
var controls = /*#__PURE__*/(0, _react.css)("display:inline-flex;justify-content:flex-end;margin-left:auto;padding-left:", (0, _util.rem)(12), ";flex-shrink:0;min-width:", (0, _util.rem)(118), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:controls;"));
var styles = {
  base: base,
  imageBox: imageBox,
  controls: controls
};
exports.styles = styles;
//# sourceMappingURL=AppCard.styles.js.map